import React from "react";
import { NavLink } from "react-router-dom";

import { getNotificationSettingsPath } from "utils/router.utils";
import { AlarmPageStrings, ReportStrings } from "constants/constantStrings";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import TextWithRightArrow from "components/TextWithRightArrow";

import "./index.scss";

const Reports = ({ props, sysId }) => (
  <div className="report__secondarymenu--links">
    {/* Bug - 99572: Commenting Report History option */}
    {/* <NavLink to={`../${SYSTEMS_PAGES.REPORTS_HISTORY}`} key={sysId}>
        <TextWithRightArrow text={ReportStrings.reportHistory} />
      </NavLink> */}
    <NavLink to={`../${SYSTEMS_PAGES.ALARMS}`} state={{ tab: 2 }}>
      <TextWithRightArrow text={AlarmPageStrings.alarmList} />
    </NavLink>
    <NavLink to={getNotificationSettingsPath()}>
      <TextWithRightArrow text={ReportStrings.reportNotification} />
    </NavLink>
  </div>
);

export default Reports;
